let self = {};

self.toFixed = (num, precision) => {
	if (num === "" || num === null) {
		return null;
	}

	let fixedVal = (+(Math.sign(num) * Math.round(+(Math.abs(num) + "e" + precision)) + "e" + -precision)).toFixed(
		precision
	);
	fixedVal = !isNaN(fixedVal) ? fixedVal : null;

	return fixedVal;
};

export const utilityService = self;
export default self;
